import { AssignmentPresetType } from '../redux/login/login.types';

export const MAX_SHARE_JOBS = 999;

export interface ShareSplitStateInput {
    appliedPreset?: AssignmentPresetType;
    sendSubaccountViaEmailDisabled?: boolean;
    selectedCount: number;
    quickSharing: boolean;
}

export interface ShareSplitState {
    showSplit: boolean;
    presetEmails: string[];
    baseDisabled: boolean;
    quickDisabled: boolean;
}

export const getShareSplitState = ({
    appliedPreset,
    sendSubaccountViaEmailDisabled,
    selectedCount,
    quickSharing,
}: ShareSplitStateInput): ShareSplitState => {
    const presetEmails = appliedPreset?.receiver?.emails ?? [];
    const baseDisabled = selectedCount === 0 || selectedCount > MAX_SHARE_JOBS;
    const showSplit = !!appliedPreset && !sendSubaccountViaEmailDisabled;
    const quickDisabled = baseDisabled || presetEmails.length === 0 || quickSharing;

    return { showSplit, presetEmails, baseDisabled, quickDisabled };
};
